import React from "react";
import "../../../css/mainLayout/header/header.css";
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js/aes';
import DecryptUtf8 from 'crypto-js/enc-utf8';
import elabLogo from "../../../images/elab-1.png";
import discLogo from "../../../images/disc-icon.png";
import RaceDesktopLogo from '../../../images/logo-white-flag.png';
import RaceMobileLogo from '../../../images/r-mobile-logo.png';
import HpLogo from '../../../images/hp-icon.png';
import axios from "axios";
import {isMobile} from 'react-device-detect';
import YouMustBeLogged from '../../modals/youmustbelogged';
import { getHeadersAuthorization } from '../../utilityFunctions/apiheadersauthorization';
import LoginButtonCTA from '../../login/loginButtonCTA';

export default class Header extends React.Component{ 

   constructor(props){
      super(props);

      this.state = {
         isAdmin: false,
      }

      this.cookies = new Cookies();
      this.data = '';
      this.config = null;

      let cookie = this.cookies.get('data');

      if(cookie){
         this.config = {
            headers: getHeadersAuthorization(cookie)
        };
         this.data = CryptoJS.decrypt(cookie, process.env.REACT_APP_CRYPT_KEY).toString(DecryptUtf8).split('%');
         //data[0]=uid, data[1]=token, data[2]=username
      }
   }

   clearStorage(event){
      event.preventDefault();
      this.cookies.remove('data', { path: '/' });
      window.location.replace("/login");
   }

   componentDidMount() {
      const toPost={
         uid: this.data[0]
     };

     axios.post(process.env.REACT_APP_API_HOST + "user/isadmin", toPost, this.config)
     .then((response) => {
         this.setState({isAdmin: response.data.items});
     }).catch((error) => {
     });
   }

   isLogged(token){
      if(token){
         //se è loggato, tasto esci
         return(<div className = "navbar-nav user-header-menu">
                  <li className = "nav-item dropdown">
                     {/* eslint-disable-next-line */}
                     <a className = "nav-link nav-item dropdown-toggle username-menu menu-step" href="#" id="dropdownLogged" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="username">
                           {this.data[2]}
                        </div>
                     </a>
                     <div className = "dropdown-menu dropdown-menu-right" aria-labelledby="dropdownLogged">
                        {/* eslint-disable-next-line */}
                        {this.state.isAdmin ? (<a className = "dropdown-item" href="/admin">Lato Admin</a>) : ('')}
                        <a className = "dropdown-item" href="/user/posts">I miei post</a>
                        <a className = "dropdown-item" href="/user/details">Visualizza account</a>
                        <a className = "dropdown-item" href="/contactus">Contattaci</a>
                        {/* eslint-disable-next-line */}
                        <a className = "dropdown-item text-danger" href="#" onClick={this.clearStorage.bind(this)}>Esci</a>
                     </div>
                  </li>
               {/* <a href="/user/details" className="nav-item nav-link username">{this.data[2]}</a>
               <button type="button" className = "btn btn-danger" onClick={this.clearStorage.bind(this)}>Esci</button> */}
               </div>);
      }else{
         //se non è loggato:
         //dropdown login e registrati su mobile
         if(isMobile) {
            return(
               <div className = "guest-user-menu">
                  {/* eslint-disable-next-line */}
                  <a className = "" href="#" id="dropdownGuest" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                  </a>
                  <div className = "dropdown-menu dropdown-menu-right" aria-labelledby="dropdownGuest">
                     <LoginButtonCTA className="dropdown-item" />
                     <a className = "dropdown-item" href="/register">Registrati</a>
                  </div>
               </div>
            );
         } else {
            //link login e registrati su desktop
            return(
               <div className = "navbar-nav">
                  <LoginButtonCTA className="nav-item nav-link bg-transparent" style={{'border':'none'}}/>
                  <a className="nav-item nav-link" href="/register">Registrati</a>
               </div>
            );
         }
         
      }
   }

   whoIsActive(){
      let url = window.location.href.split('/');
      if(url[3] === 'elaborations'){
         return [<div className="menu-active"></div>, '', ''];
      }else if(url[3] === 'discussions'){
         return ['', <div className="menu-active"></div>, ''];
      }else if(url[3].length === 0){
         return ['', '', <div className="menu-active"></div>];
      }else{
         return ['', '', ''];
      }
   }

   render(){ 
      const toDisplay = this.isLogged(this.data[1]);
      const isActive = this.whoIsActive();

      return( 
         <div>
            <nav className="navbar fixed-top navbar-expand navbar-light navbar-custom">
               <a className="navbar-nav navbar-brand center-brand first-step" href="/">
                  {!isMobile ? (
                     <img src={RaceDesktopLogo} width={'150px'} alt="race-logo"></img>
                  ) : (
                     <img src={RaceMobileLogo} width={'40px'} alt="race-logo"></img>
                  )}
               </a>
               <div className="navbar-nav header-menu-margins second-step">
                  {
                     this.data[1] ? (
                        <>
                        <a className="nav-item nav-link" href="/elaborations" style={{paddingBottom: isActive[0]!=='' ? '0px' : '8px'}}>
                           <img className="elab-step" src={elabLogo} width="35px" height="35px" alt="elab-logo"/>
                           {isActive[0]}
                        </a>

                        <a className="nav-item nav-link" href="/" style={{paddingBottom: isActive[2]!=='' ? '0px' : '8px'}}>
                           <img className="hp-step" src={HpLogo} width="35px" height="35px" alt="hpcalc-logo"/>
                           {isActive[2]}
                        </a>

                        <a className="nav-item nav-link" href="/discussions" style={{paddingBottom: isActive[1]!=='' ? '0px' : '8px'}}>
                           <img className="disc-step" src={discLogo} width="35px" height="35px" alt="disc-logo"/>
                           {isActive[1]}
                        </a>
                        </>
                     ):(
                        <>
                        <YouMustBeLogged section={'Elaborazioni'} />
                        <a className="nav-item nav-link" href="/" style={{paddingBottom: isActive[2]!=='' ? '0px' : '8px'}}>
                           <img src={HpLogo} width="35px" height="35px" alt="hpcalc-logo"/>
                           {isActive[2]}
                        </a>
                        <YouMustBeLogged section={'Discussioni'} />
                        </>
                     )
                  }
               </div>
               {toDisplay}
            </nav>
            
         </div>
      ); 
   }
}